<template>
  <header class="header">
    <div class="container">
      <div class="header__row">
        <router-link to="/en/home" class="logo-link" @click.native="handleClick" v-if="Rus[1] === 'en'">
          <img
            src="@/assets/images/logo.svg"
            class="logo"
          >
        </router-link>
        <router-link to="/" class="logo-link" @click.native="handleClick" v-else>
          <img
            src="@/assets/images/logo.svg"
            class="logo"
          >
        </router-link>

        <nav class="nav nav_hidden_mob" v-if="Rus[1] === 'en'">
          <router-link to="/en/mission" class="nav-item">Our Values</router-link>
          <router-link to="/en/services" class="nav-item">What we do</router-link>
          <router-link to="/en/about" class="nav-item">Team</router-link>
          <router-link to="/en/contacts" class="nav-item">Contacts</router-link>
        </nav>
        <nav class="nav nav_hidden_mob" v-else>
          <router-link to="/mission" class="nav-item">Наши ценности</router-link>
          <router-link to="/services" class="nav-item">Что мы делаем</router-link>
          <router-link to="/about" class="nav-item">Команда</router-link>
          <router-link to="/contacts" class="nav-item">Контакты</router-link>
        </nav>
        <div class="lang">
          <router-link to="/" class="nav-item lang_not" :class="{lang_active: Rus[1] !== 'en'}">RU</router-link>
          <span>|</span>
          <router-link to="/en/home" class="nav-item lang_not" :class="{lang_active: Rus[1] === 'en'}">EN</router-link>
        </div>
        <div
          class="nav-burger"
          :class="{ 'nav-burger_active': isVisibleMobMenu }"
          @click="isVisibleMobMenu = !isVisibleMobMenu"
        >
          <div class="nav-burger__item"></div>
          <div class="nav-burger__item"></div>
          <div class="nav-burger__item"></div>
        </div>
      </div>
    </div>

    <div
      class="mobile-menu"
      :class="{ 'mobile-menu_active': isVisibleMobMenu }"
    >
      <div class="container">
        <div class="mobile-menu-nav">
          <router-link to="/mission" class="mobile-menu-nav__item" @click.native="handleClick">
            <h3 class="mobile-menu-nav__title">Наши ценности</h3>
          </router-link>
          <router-link to="/services" class="mobile-menu-nav__item" @click.native="handleClick">
            <h3 class="mobile-menu-nav__title">Что мы делаем</h3>
          </router-link>
          <router-link to="/about" class="mobile-menu-nav__item" @click.native="handleClick">
            <h3 class="mobile-menu-nav__title">Команда</h3>
          </router-link>
          <router-link to="/contacts" class="mobile-menu-nav__item" @click.native="handleClick">
            <h3 class="mobile-menu-nav__title">Контакты</h3>
          </router-link>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { TweenMax } from 'gsap'

export default {
  name: 'Header',
  data () {
    return {
      isVisibleMobMenu: false
    }
  },
  computed: {
    isContactsPage () {
      return this.$route.name === 'contacts'
    },
    Rus() {
      const name = this.$route.path
      return name.split('/', 2)
    }
  },
  mounted () {
    TweenMax.from('.nav-item:nth-child(1)', 0.3, { y: '-10px', opacity: 0 })
    TweenMax.from('.nav-item:nth-child(2)', 0.3, { y: '-10px', opacity: 0, delay: 0.15 })
    TweenMax.from('.nav-item:nth-child(3)', 0.3, { y: '-10px', opacity: 0, delay: 0.3 })
    TweenMax.from('.nav-item:nth-child(4)', 0.3, { y: '-10px', opacity: 0, delay: 0.45 })
  },
  methods: {
    handleClick () {
      this.isVisibleMobMenu = false
    }
  }
}
</script>
